module.exports = __webpack_public_path__ + "img/lowest.26a76b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowest.png
// module id = 275
// module chunks = 0